<script context="module">
  import EmailMarketingSettings from './Settings.svelte';

  export function verifyBrandDetails() {
    return new Promise((resolve) => {
      if (!Website.emailMarketingSettings.companyName || !Website.emailMarketingSettings.companyAddress) {
        Tools.showWindow({
          isModal: true,
          title: M.BRAND_DETAILS,
          width: 500,
          buttons: [],
          noNav: true,
          markup: '<div class="popup-widget-wrapper bind-component"></div>',
          //forceAtRight: window.showBuilderPopupsOnFullHeight,
          action: {
            onShow: (popup, ui) => {
              popup.bindComponent(
                new EmailMarketingSettings({
                  target: ui.find('.bind-component')[0],
                  props: {
                    brandDetailsOnly: true,
                    onSaved: () => {
                      popup.close();
                      resolve(Website.emailMarketingSettings);
                    }
                  }
                })
              );
            }
          }
        });
      } else {
        resolve(Website.emailMarketingSettings);
      }
    });
  }
</script>

<script>
  import { ignore, makeWebsiteRequest } from '../../Common/tools';
  import { onMount } from 'svelte';
  import { External, M } from '../../external';

  export let brandDetailsOnly = false,
    onSaved = ignore;
  let verifiedDomains = [];
  let defaultEmail = '';
  let systemEmail = '';
  let replyEmail = '';
  let defaultSender;
  let companyName;
  let companyAddress;
  let withDefaultEmailError = false;
  let withSystemEmailError = false;
  let inactivityPeriod = '6';
  let unopenedEmails = '10';
  let inactivityAction = 'unsubscribe';
  let showUnsubscriptionDisclaimer = false;
  let defaultInactivityAction = 'none';

  async function loadDomains() {
    let response = await makeWebsiteRequest({
      action: 'getMarketingSettings'
    });

    if (!response.data) {
      return;
    }

    let domains = response.data.domains;
    defaultSender = response.data.defaultSender;
    systemEmail = response.data.systemEmail;
    replyEmail = response.data.replyEmail;
    defaultEmail = response.data.defaultEmail;
    companyName = response.data.companyName;
    companyAddress = response.data.companyAddress;
    let unsubscriptionSettings = response.data.unsubscriptionSettings || {};
    inactivityPeriod = '' + (unsubscriptionSettings.inactivityPeriod || 6);
    unopenedEmails = '' + (unsubscriptionSettings.unopenedEmails || 10);
    inactivityAction = unsubscriptionSettings.inactivityAction || defaultInactivityAction;

    domains.forEach((details) => {
      if (details.verificationStatus === 'VERIFIED' && details.dkimStatus === 'VERIFIED') {
        verifiedDomains.push(details.domain);
      }
    });
  }

  let saveSettings = () => {
    External.Tools.makeWebsiteRequest({
      action: 'setMarketingSettings',
      incrementModCount: true,
      data: {
        defaultSender: brandDetailsOnly ? '' : defaultSender,
        defaultEmail: brandDetailsOnly ? '' : defaultEmail,
        systemEmail: brandDetailsOnly ? '' : systemEmail,
        replyEmail: brandDetailsOnly ? '' : replyEmail,
        companyName: companyName,
        companyAddress: companyAddress,
        inactivityPeriod: inactivityPeriod,
        unopenedEmails: unopenedEmails,
        inactivityAction: inactivityAction
      },
      onOk: function() {
        External.Website.emailMarketingSettings.companyName = companyName;
        External.Website.emailMarketingSettings.companyAddress = companyAddress;
        if (!brandDetailsOnly) {
          External.Website.emailMarketingSettings.systemEmail = systemEmail;
          External.Website.emailMarketingSettings.defaultEmail = defaultEmail;
          External.Website.emailMarketingSettings.defaultSender = defaultSender;
          External.Website.emailMarketingSettings.replyEmail = replyEmail;
          let unsubscriptionSettings = External.Website.emailMarketingSettings.unsubscriptionSettings || {};
          unsubscriptionSettings.inactivityPeriod = inactivityPeriod;
          unsubscriptionSettings.unopenedEmails = unopenedEmails;
          unsubscriptionSettings.inactivityAction = inactivityAction;
          External.Website.emailMarketingSettings.unsubscriptionSettings = unsubscriptionSettings;
        }
        External.Tools.showAutohideMessage(5, M.DOMAIN_SETTINGS_SAVED);
        onSaved();
      }
    });
  };

  $: {
    let emailParts;
    if (defaultEmail) {
      emailParts = defaultEmail.split('@');
      withDefaultEmailError = defaultEmail && (emailParts.length != 2 || verifiedDomains.indexOf(emailParts[1]) < 0);
    }

    if (systemEmail) {
      emailParts = systemEmail.split('@');
      withSystemEmailError = systemEmail && (emailParts.length != 2 || verifiedDomains.indexOf(emailParts[1]) < 0);
    }
  }

  onMount(function() {
    let websiteCreatedTime = new Date(External.createdTime * 1000);
    // started tracking on June 1st, 2026. Showing the disclaimer for websites created before May 15th, 2026.
    showUnsubscriptionDisclaimer = websiteCreatedTime.getFullYear() < 2026 || websiteCreatedTime.getMonth() < 4 || websiteCreatedTime.getMonth() === 4 && websiteCreatedTime.getDate() <= 15;

    if (websiteCreatedTime.getFullYear() < 2026 || websiteCreatedTime.getMonth() < 5 || websiteCreatedTime.getMonth() === 5 && websiteCreatedTime.getDate() <= 29) {
      // defaultInactivityAction is none for websites created before June 29th, 2026.
      defaultInactivityAction = 'none';
    } else {
      defaultInactivityAction = 'unsubscribe';
    }

    loadDomains();
  });
</script>

{#if brandDetailsOnly}
  <div class="col20 f-left">
    <div class="email-inputs-wrapper">
      <div class="col20 f-left flex flex-col mb-35">
        <div class="flex-1">
          <span class="light-gray-text col20 f-left mb-15 t-center">{M.BRAND_DETAILS_DESC}</span>
        </div>
      </div>

      <div class="popup-input-wrapper">
        <h5>{M.MARKETING_COMPANY_NAME}</h5>
        <span class="light-gray-text">{M.MARKETING_COMPANY_EMAIL_DESC}</span>
        <input type="text" bind:value={companyName} placeholder={M.MARKETING_COMPANY_NAME} />
      </div>
      <div class="popup-input-wrapper">
        <h5>{M.MARKETING_COMPANY_ADDRESS}</h5>
        <span class="light-gray-text">{M.MARKETING_COMPANY_ADDRESS_DESC}</span>
        <input type="text" bind:value={companyAddress} placeholder={M.MARKETING_COMPANY_ADDRESS} />
      </div>
      <div class="col20 f-left flex justify-center mt-5 mb-5">
        <a data-action="saveSettings" on:click={saveSettings} class="big-button blue circle-effect transition-bg f-left">{M.SAVE}</a>
      </div>
    </div>
  </div>
{:else}
  <div class="mt-25 col20 f-left mb-25">
    <div class="email-inputs-wrapper">
      <div class="col20 f-left flex flex-col">
        <div class="flex-1">
          <h3 class="col20 f-left mb-5 t-center">{M.BRAND_DETAILS}</h3>
          <span class="light-gray-text col20 f-left mb-15 t-center">{M.BRAND_DETAILS_DESC}</span>
        </div>
      </div>
      <div class="popup-input-wrapper mt-25">
        <h5>{M.MARKETING_COMPANY_NAME}</h5>
        <span class="light-gray-text">{M.MARKETING_COMPANY_EMAIL_DESC}</span>
        <input type="text" bind:value={companyName} placeholder={M.MARKETING_COMPANY_NAME} />
      </div>
      <div class="popup-input-wrapper">
        <h5>{M.MARKETING_COMPANY_ADDRESS}</h5>
        <span class="light-gray-text">{M.MARKETING_COMPANY_ADDRESS_DESC}</span>
        <input type="text" bind:value={companyAddress} placeholder={M.MARKETING_COMPANY_ADDRESS} />
      </div>
      <div class="popup-input-wrapper">
        <h5>{M.DEFAULT_SENDER_NAME}</h5>
        <span class="light-gray-text">{M.DEFAULT_SENDER_NAME_DESC}</span>
        <input type="text" bind:value={defaultSender} placeholder={M.ENTER_SENDER_NAME} />
      </div>
      <div class="popup-input-wrapper">
        <h5>{M.DEFAULT_EMAIL}</h5>
        <span class="light-gray-text">{M.DEFAULT_EMAIL_DESC}</span>
        <input type="text" bind:value={defaultEmail} placeholder={M.ENTER_EMAIL_HERE} />
        <div class:none={!withDefaultEmailError}>
          <span class="f-left mt-10 red-text">{M.WRONG_EMAIL_WARNING}</span>
        </div>
      </div>
      <div class="popup-input-wrapper">
        <h5>{M.DEFAULT_REPLY_EMAIL}</h5>
        <span class="light-gray-text">{M.DEFAULT_REPLY_EMAIL_DESC}</span>
        <input type="text" bind:value={replyEmail} placeholder={M.ENTER_EMAIL_HERE} />
      </div>
      <div class="popup-input-wrapper">
        <h5>{M.DEFAULT_SENDER_EMAIL}</h5>
        <span class="light-gray-text">{M.DEFAULT_SENDER_EMAIL_DESC}</span>
        <input type="text" bind:value={systemEmail} placeholder={M.ENTER_EMAIL_HERE} />
        <div class:none={!withSystemEmailError}>
          <span class="f-left mt-10 red-text">{M.WRONG_EMAIL_WARNING}</span>
        </div>
      </div>
      <div class="popup-input-wrapper">
        <h5>{M.INACTIVITY_DETECTION}</h5>
        <span class="light-gray-text">{M.INACTIVITY_DETECTION_DESC}</span>
        <div class="flex flex-row" style="align-items: center">
          <select id="inactivityPeriodSelect" bind:value={inactivityPeriod} style="width: 80px;">
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
          </select>
          <label for="inactivityPeriodSelect" class="ml-5"
                 style="display: inline-block; vertical-align: middle; line-height: normal">{M.INACTIVITY_MONTHS}</label>
          <span class="ml-5 mr-5 bold">{M.OR}</span>
          <select id="unopenedEmailsSelect" bind:value={unopenedEmails} style="width: 80px;">
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
            <option value="13">13</option>
            <option value="14">14</option>
            <option value="15">15</option>
            <option value="16">16</option>
            <option value="17">17</option>
            <option value="18">18</option>
            <option value="19">19</option>
            <option value="20">20</option>
          </select>
          <label for="unopenedEmailsSelect" class="ml-5"
                 style="display: inline-block; vertical-align: middle; line-height: normal">{M.INACTIVITY_EMAILS}</label>
        </div>
        <h5 class="mt-15">{M.INACTIVITY_ACTION}</h5>
        <span class="light-gray-text">{M.INACTIVITY_ACTION_DESC}</span>
        <div class="flex flex-row" style="align-items: center">
          <select class="col20" bind:value={inactivityAction}>
            <option value="none">{M.DO_NOTHING}</option>
            <option value="unsubscribe">{M.UNSUBSCRIBE}</option>
          </select>
        </div>
        {#if showUnsubscriptionDisclaimer}
          <sub>{M.INACTIVITY_DETECTION_DISCLAIMER}</sub>
        {/if}
      </div>
      <div class="col20 f-left flex justify-center mt-5 mb-5">
        <a data-action="saveSettings" on:click={saveSettings} class="big-button blue circle-effect transition-bg f-left">{M.SAVE}</a>
      </div>
    </div>
  </div>
{/if}
